module.exports = {
  ...require("./departements"),
  ...require("./directions"),
  ...require("./index"),
  ...require("./mesures"),
  ...require("./pays"),
  ...require("./users"),
};
